import { useAppDispatch, useAppSelector } from "app/hooks";
import { setTopDownView } from "features/krpano/details-slice";
import { useEffect } from "react";
import { notNullNorUndefined } from "shared/helpers/notNullNorUndefined";

const NORMAL_VIEW = "setViewAngle(false);";
const TOP_DOWN_VIEW = "setViewAngle(true);";

type UseTopDownView = (krpanoFeaturesReady: boolean) => void;

/**
 * # View mode for krpano
 *
 * @param krpanoFeaturesReady see `AppInner`
 */
export const useTopDownView: UseTopDownView = (krpanoFeaturesReady) => {
  const topDownView = useAppSelector((state) => state.krpano.topDownView);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (krpanoFeaturesReady) {
      window.krpano.call(topDownView ? TOP_DOWN_VIEW : NORMAL_VIEW);
    }
  }, [krpanoFeaturesReady, topDownView]);

  // This listener is for when krpano is used to change the view
  useEffect(() => {
    const setTopDownHandler = (
      event: WindowEventMap["krpano__set_top_down"]
    ) => {
      if (
        notNullNorUndefined(event.detail) &&
        notNullNorUndefined(event.detail.topDown)
      ) {
        dispatch(setTopDownView(event.detail.topDown));
      } else {
        // TODO: KrpanoDispatchedEvent Error handling
      }
    };
    window.addEventListener("krpano__set_top_down", setTopDownHandler);
    return () => {
      window.removeEventListener("krpano__set_top_down", setTopDownHandler);
    };
  }, [dispatch]);
};
